/**
 * Grid Simulation Plugin
 *
 * GridInit → GridBuffer → System chain → GridBuffer (feedback loop)
 * GridBuffer.current → GridViz (visualization)
 */

import type { Plugin } from '@plugins/Plugin';
import { Domain } from '@nodes/Endpoint';
import { gridInitNodeDef } from './nodes/GridInitNode';
import { gridBufferNodeDef } from './nodes/GridBufferNode';
import { gridTransformNodes } from './nodes/GridTransformNode';
import { noise2DNodeDef, gridlines2DNodeDef, random2DNodeDef, gradient2DNodeDef } from './nodes/GeneratorNodes';
import { gridVizNodeDef } from './nodes/GridVizNode';

const allNodes = [
  gridInitNodeDef,
  gridBufferNodeDef,
  ...gridTransformNodes,
  noise2DNodeDef,
  gridlines2DNodeDef,
  random2DNodeDef,
  gradient2DNodeDef,
  gridVizNodeDef,
];

export const gridPlugin: Plugin = {
  id: 'grid',
  name: 'grid',
  namespace: 'grid',
  domain: Domain.Data,
  nodes: allNodes,

  createNode(type: string, id: string, deps: any) {
    const nodeDef = this.nodes!.find(n => n.type === type);
    if (!nodeDef) {
      throw new Error(`Unknown ECS node type: ${type}`);
    }
    return new nodeDef.ctor(id, deps);
  },

  async registerUI({ registerViz }) {
    const { GridVisualization } = await import('./nodes/GridVisualization');
    registerViz('GridViz', GridVisualization);
  },
};
